module.exports = __webpack_public_path__ + "img/perfumes.c9918ae0.png";